import React, { useMemo } from "react";
import { Modal } from "react-bootstrap";
import { CapitalizeAllWords, convertToPersian } from "../../Functions/TextTransform";

function buildWaitlistVariantLabel(activeProduct, pageLanguage) {
  if (!activeProduct?.["ProductId"]) {
    return "";
  }
  const color =
    pageLanguage === "fa"
      ? convertToPersian(activeProduct["ColorName"])
      : CapitalizeAllWords(activeProduct["ColorEnName"]);
  const size =
    pageLanguage === "fa"
      ? convertToPersian(activeProduct["ProductSizeName"])
      : activeProduct["ProductSizeEnName"];
  const lining =
    pageLanguage === "fa"
      ? activeProduct["LiningTypeName"]
      : activeProduct["LiningTypeEnName"];
  return [color, size, lining].filter(Boolean).join(" / ");
}

export default function WaitlistSuccessModalOneCurtain({
  pageLanguage,
  modals,
  modalHandleClose,
  t,
  activeProduct,
  registeredEmail,
}) {
  const variantLabel = useMemo(
    () => buildWaitlistVariantLabel(activeProduct, pageLanguage),
    [activeProduct, pageLanguage]
  );

  return (
    <Modal
      backdrop="static"
      keyboard={false}
      dialogClassName={`waitlist_success_modal noMount_modal mediumSizeModal scroll_on ${
        pageLanguage === "fa" ? "font_farsi" : "font_en"
      }`}
      show={modals["waitlist_success"] === undefined ? false : modals["waitlist_success"]}
      onHide={() => modalHandleClose("waitlist_success")}
      scrollable={true}
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <p className="measurementsHelp_modal_title measurementsHelp_modal_title_waitlist_desktop">
          {t("YOU'RE ON THE LIST")}
        </p>
      
        <p className="waitlist_success_body">
          {t("We'll email")}{" "}
          {registeredEmail} {t("when")}{" "}
          {variantLabel} {t("is back in stock.")}
        </p>
        <div className="text_center waitlist_modal_submit">
          <button
            type="button"
            className="btn btn-new-dark"
            onClick={() => modalHandleClose("waitlist_success")}
          >
            {t("Continue shopping")}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export { buildWaitlistVariantLabel };
